<template><svg class="cnm-icon" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="56" height="56" rx="28" fill="black" fill-opacity="0.5"/>
<path d="M22.167 17.5L38.5003 28L22.167 38.5V17.5Z" fill="white" stroke="white" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
